// src/requests/components/RequestUserField.tsx
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

const RequestUserField: React.FC<FieldProps<any>> = ({
    record,
    source = '',
    label,
    link = 'show',
}) => {
    if (!record) return null;

    // Get the user data based on the source field
    // Handle both nested objects and direct ID fields
    const isUser = source === 'userId';
    const userId = isUser ? record.userId : record.assigneeId;
    if (!userId) return null;

    // Get user data from either nested object or direct name property
    const userData = isUser ? record.user : record.assignee;
    const userName =
        userData?.name || (isUser ? record.userName : record.assigneeName);
    if (!userName) return null;

    // Display the user name with an optional link to the user profile
    if (link) {
        return <Link to={`/users/${userId}/show`}>{userName}</Link>;
    }

    return <span>{userName}</span>;
};

RequestUserField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string,
    label: PropTypes.string,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

RequestUserField.defaultProps = {
    record: {},
    source: 'userId',
    label: '',
    link: 'show',
};

export default RequestUserField;
